

export const VUE_APP_VERSION = (process.env.VUE_APP_VERSION || '0')
